import httpClient from "@/bundles/http-client";
import route from "@/bundles/route";
import redirect from "@/shared/redirect";

class AuthTokenResolver
{
    #fetchTokenPromise;
    #authToken;
    #baseUrl;

    constructor(baseUrl = '/api/v2') {
        this.#baseUrl = baseUrl;
    }

    uri(path) {
        return this.#baseUrl + path;
    }

    #requestNewToken() {
        const url = route('api.v2.auth');

        return httpClient.post(url,{}, {
            withCredentials: true,
        }).then((response) => {
            this.#authToken = response.data.token;
            return this.#authToken;
        }).catch((reason) => {
            if (reason?.response?.data?.code === 'unauthenticated') {
                redirect('/login?next=' + window.location.href);
            } else {
                window.location.reload();
            }
        }).finally(() => {
            this.#fetchTokenPromise = null;
        });
    }

    getToken() {
        if (this.#authToken) {
            return new Promise((resolve) => {
                resolve(this.#authToken);
            });
        }

        if (!this.#fetchTokenPromise) {
            this.#fetchTokenPromise = this.#requestNewToken();
        }

        return this.#fetchTokenPromise;
    }
}

if (typeof global.apiAuthTokenResolver === 'undefined') {
    global.apiAuthTokenResolver = new AuthTokenResolver();
}

export default global.apiAuthTokenResolver;
